import "src/decidim/decidim_awesome/admin/constraint_form_events";
import "src/decidim/decidim_awesome/admin/auto_edit";
import "src/decidim/decidim_awesome/admin/user_picker";
import "src/decidim/decidim_awesome/admin/proposal_sortings";
import "src/decidim/decidim_awesome/admin/codemirror";
import "src/decidim/decidim_awesome/admin/check_redirections";
import "src/decidim/decidim_awesome/admin/form_exit_warn";
import "src/decidim/decidim_awesome/proposals/custom_fields";
import "src/decidim/decidim_awesome/admin/custom_fields_builder";
import "src/decidim/decidim_awesome/admin/verification_selects";
window.DecidimAwesome = window.DecidimAwesome || {};
